import {SummaryData} from "../../models/ProductSummary"

export const getTileSummaryData = (summaryItemsData: {[key: string]: SummaryData}, itemNumber: string) => {
    const summaryData = summaryItemsData[itemNumber]
    if (!summaryData) {
        return {
            isConfError: true,
            itemNumber,
            firstItemNumber: itemNumber,
            colourways: [],
            category: "",
            type: "",
        } as unknown as SummaryData
    }
    return summaryData
}
